import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Brand";

export function Splash() {
  return (
    <div className="min-h-screen bg-[#D8C3A5] flex flex-col items-center justify-center gap-4" data-testid="auth-loading">
      <Logo size={84} />
      <div className="h-1.5 w-24 rounded-full bg-[#1F2A44]/20 overflow-hidden">
        <div className="h-full w-1/2 bg-[#F57C00] animate-pulse" />
      </div>
    </div>
  );
}

export default function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Splash />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
